import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  const points = [{
    emoji: '🌙',
    text: 'Quieres que la hora de dormir sea un momento de calma y conexión familiar…'
  }, {
    emoji: '✨',
    text: 'Deseas transmitir enseñanzas espirituales importantes sin rigidez ni miedo…'
  }, {
    emoji: '💞',
    text: 'Buscas historias que ayuden a tu hijo a sentirse amado, protegido y en paz…'
  }, {
    emoji: '📖',
    text: 'Y te encantaría encontrar cuentos con mensajes positivos que también emocionen a los adultos…'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-white/40" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-41">
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-indigo mb-6" data-id="element-42">
            ¿Te suena familiar?
          </h2>
          <p className="text-lg md:text-xl text-indigo/80 max-w-2xl mx-auto leading-relaxed" data-id="element-43">
            En medio de un mundo lleno de ruido y distracciones, una historia
            contada con amor puede llenar de paz, luz y tranquilidad el corazón
            de un niño.
          </p>
          <p className="text-lg md:text-xl text-indigo font-medium mt-6" data-id="element-44">
            Y ahora puedes vivir ese momento especial cada noche con:
          </p>
          <p className="text-2xl font-serif text-gold mt-4" data-id="element-45">
            🌙 Guía de cuentos espirituales para niños antes de dormir
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-46">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-8 rounded-3xl shadow-sm flex items-start gap-4" data-id="element-47">
              <span className="text-3xl shrink-0" data-id="element-48">{point.emoji}</span>
              <p className="text-indigo/90 text-lg leading-relaxed font-medium" data-id="element-49">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}